import {
  faSortAlphaDown,
  faSortAlphaUpAlt,
  faSortNumericDown,
  faSortNumericUpAlt,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { ISorted } from '@feathr/components';
import { MenuItem, SortMenu } from '@feathr/components';

interface IProps {
  onChange: (newValue: ISorted) => void;
  value: ISorted;
}

const sortMap: Record<string, ISorted> = {
  nameAsc: { id: 'name' },
  nameDesc: { id: 'name', desc: true },
  createdAsc: { id: 'date_created' },
  createdDesc: { id: 'date_created', desc: true },
  startAsc: { id: 'date_start' },
  startDesc: { id: 'date_start', desc: true },
  endAsc: { id: 'date_end' },
  endDesc: { id: 'date_end', desc: true },
};

function currentSort(sort: ISorted): string | undefined {
  return Object.keys(sortMap).find(
    (key) => sortMap[key].id === sort.id && sortMap[key].desc === sort.desc,
  );
}

function EventsPageSort({ onChange, value }: IProps): JSX.Element {
  const { t } = useTranslation();

  function getHandleClick(sort: ISorted) {
    return () => onChange(sort);
  }

  return (
    <SortMenu>
      <MenuItem
        buttonClassName={classNames({ active: currentSort(value) === 'nameAsc' })}
        onClick={getHandleClick(sortMap.nameAsc)}
        suffix={<FontAwesomeIcon icon={faSortAlphaDown} />}
      >
        {t('Alpha (asc)')}
      </MenuItem>
      <MenuItem
        buttonClassName={classNames({ active: currentSort(value) === 'nameDesc' })}
        onClick={getHandleClick(sortMap.nameDesc)}
        suffix={<FontAwesomeIcon icon={faSortAlphaUpAlt} />}
      >
        {t('Alpha (desc)')}
      </MenuItem>
      <MenuItem
        buttonClassName={classNames({ active: currentSort(value) === 'createdAsc' })}
        onClick={getHandleClick(sortMap.createdAsc)}
        suffix={<FontAwesomeIcon icon={faSortNumericDown} />}
      >
        {t('Oldest')}
      </MenuItem>
      <MenuItem
        buttonClassName={classNames({ active: currentSort(value) === 'createdDesc' })}
        onClick={getHandleClick(sortMap.createdDesc)}
        suffix={<FontAwesomeIcon icon={faSortNumericUpAlt} />}
      >
        {t('Newest')}
      </MenuItem>
      <MenuItem
        buttonClassName={classNames({ active: currentSort(value) === 'startAsc' })}
        onClick={getHandleClick(sortMap.startAsc)}
        suffix={<FontAwesomeIcon icon={faSortNumericDown} />}
      >
        {t('Start date (asc)')}
      </MenuItem>
      <MenuItem
        buttonClassName={classNames({ active: currentSort(value) === 'startDesc' })}
        onClick={getHandleClick(sortMap.startDesc)}
        suffix={<FontAwesomeIcon icon={faSortNumericUpAlt} />}
      >
        {t('Start date (desc)')}
      </MenuItem>
      <MenuItem
        buttonClassName={classNames({ active: currentSort(value) === 'endAsc' })}
        onClick={getHandleClick(sortMap.endAsc)}
        suffix={<FontAwesomeIcon icon={faSortNumericDown} />}
      >
        {t('End date (asc)')}
      </MenuItem>
      <MenuItem
        buttonClassName={classNames({ active: currentSort(value) === 'endDesc' })}
        onClick={getHandleClick(sortMap.endDesc)}
        suffix={<FontAwesomeIcon icon={faSortNumericUpAlt} />}
      >
        {t('End date (desc)')}
      </MenuItem>
    </SortMenu>
  );
}

export default EventsPageSort;
